'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _arrayToDate = require('@marmalade/date/lib/array-to-date');
var _arrayToDate2 = _interopRequireDefault(_arrayToDate);
var _inNoMoreThanDays = require('@marmalade/validation/lib/in-no-more-than-days');
var _inNoMoreThanDays2 = _interopRequireDefault(_inNoMoreThanDays);
var _is = require('@marmalade/validation/lib/is');
var _is2 = _interopRequireDefault(_is);
var _notInPast = require('@marmalade/validation/lib/not-in-past');
var _notInPast2 = _interopRequireDefault(_notInPast);
var _oneByOne = require('@marmalade/validation/lib/one-by-one');
var _oneByOne2 = _interopRequireDefault(_oneByOne);
var _oneOf = require('@marmalade/validation/lib/one-of');
var _oneOf2 = _interopRequireDefault(_oneOf);
var _validDate = require('@marmalade/validation/lib/valid-date');
var _validDate2 = _interopRequireDefault(_validDate);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
exports.default = function (o) {
  return {
    coverStartDate: (0, _oneByOne2.default)((0, _validDate2.default)(), (0, _notInPast2.default)('Start date cannot be in the past'), function (value) {
      return (0, _arrayToDate2.default)(value) >= (0, _arrayToDate2.default)(o.licenceStartDate) ? '' : 'The policy cannot start before the start date of your provisional licence';
    }, function (value) {
      var dob = [].concat(_toConsumableArray(o.dateOfBirth));
      dob[2] = ~~dob[2] + 17;
      return (0, _arrayToDate2.default)(value) >= (0, _arrayToDate2.default)(dob) ? '' : 'You must be at least 17 years old when the policy starts';
    }, (0, _inNoMoreThanDays2.default)(30, 'Start date cannot be more than 30 days into the future')),
    cover: (0, _oneOf2.default)(['30', '60', '90', '120', '180', '240']),
    policySummary: (0, _is2.default)('Y'),
    statements: (0, _is2.default)('Y'),
    donation: (0, _oneOf2.default)(['true', 'false'])
  };
};